import Popover from './Popover';
import Button from '../Button/Button';

/**
 * QHS FormPopover (Tier 3)
 * -------------------------
 * For multi-select filters, date ranges, two-column pickers.
 * Requires explicit Apply / Cancel commit.
 *
 *   <FormPopover
 *     open={open} onClose={close}
 *     trigger={<Button>Filters</Button>}
 *     title="Filter by tags"
 *     headAction={{ label: 'Clear all', onClick: clear }}
 *     onApply={() => ...}
 *     onCancel={close}
 *     applyLabel="Apply (3)"
 *   >
 *     ...body...
 *   </FormPopover>
 */
const FormPopover = ({
  open,
  onClose,
  trigger,
  title,
  headAction,
  onApply,
  onCancel,
  applyLabel = 'Apply',
  cancelLabel = 'Cancel',
  applyDisabled = false,
  bodyPadded = false,
  placement = 'bottom-start',
  children,
  ...rest
}) => (
  <Popover open={open} onClose={onClose} trigger={trigger} placement={placement} {...rest}>
    {title && (
      <div className="qhs-pop__head">
        <h5>{title}</h5>
        {headAction && (
          <button type="button" className="qhs-pop__head-action" onClick={headAction.onClick}>
            {headAction.label}
          </button>
        )}
      </div>
    )}
    <div className={`qhs-pop__body${bodyPadded ? ' qhs-pop__body--padded' : ''}`}>
      {children}
    </div>
    <div className="qhs-pop__foot">
      <Button variant="ghost" size="sm" onClick={onCancel ?? onClose}>{cancelLabel}</Button>
      <Button variant="primary" size="sm" onClick={onApply} disabled={applyDisabled}>{applyLabel}</Button>
    </div>
  </Popover>
);

export default FormPopover;
